import { render, staticRenderFns } from "./IcmsIpiTab.vue?vue&type=template&id=edcf31d2&"
import script from "./IcmsIpiTab.vue?vue&type=script&lang=js&"
export * from "./IcmsIpiTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports